<app-page-loader />
<!-- <div class="sign-in-page">
    <citadel-form-section [heading]="'Sign Out'">
        <div class="button-strip">
            <citadel-button (click)="goBack()" >Cancel</citadel-button>&nbsp;
            <citadel-button [primary]="true" [isSubmit]="true" (click)="signOut()" >Sign Out</citadel-button>
        </div>
    </citadel-form-section>
</div> -->